import React from "react";
import { Link } from "react-router-dom";

export interface ButtonPrimaryProps {
  className?: string;
  to?: string;
  href?: string;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  to,
  href,
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  children,
}) => {
  const CLASSES = `
    inline-flex items-center justify-center gap-2
    rounded-full bg-primary text-white hover:bg-primary/80
    disabled:bg-opacity-70 transition-colors
    px-4 py-2
    ${className}
  `;

  const renderLoading = () => (
    <svg
      className="size-5 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );

  const content = (
    <>
      {loading && renderLoading()}
      <span>{children}</span>
    </>
  );

  if (to || href) {
    return (
      <Link to={to || href!} className={CLASSES} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={CLASSES}
      onClick={onClick}
    >
      {content}
    </button>
  );
};

export default ButtonPrimary;
